import React from 'react';
import { IEnquiryOptionProps } from '../../interfaces/EnquiryInterface';
import { InformationModal } from '../Common/InformationModal/InformationModal';
import { EnquiryOptionDropDown } from './EnquiryOptionDropDown';
import { EnquiryOptionsGroups } from './EnquiryOptionGroups';
import { EnquiryOptionTextBox } from './EnquiryOptionTextBox';
import { EnquiryOptionConsentCheckBox } from './EnquiryOptionConsentCheckBox';

export const EnquiryOptions: React.FC<IEnquiryOptionProps> = (
  props: IEnquiryOptionProps
) => {
  const renderOptions = () => {
    if (
      props.inputType === 'checkbox' ||
      props.inputType === 'RadioButtonList'
    ) {
      return (
        <>
          <EnquiryOptionsGroups
            inputType={props.inputType}
            questionType={props.questionType}
            options={props.options}
            selectedValue={props.selectedValue}
            handleChange={props.handleChange}
            alignCenter={props.alignCenter}
            labelText={props.labelText}
            labelDescription={props.labelDescription}
            helpText={props.helpText || ''}
            isVertical={props.isVertical}
            ariaDescribedBy={`${props.questionType}-info`}
          />

          {props.moreInformation && (
            <div className="pt-1">
              <InformationModal
                linkText={props.moreInformation?.text}
                modalContent={props.moreInformation?.description}
                heading={props.moreInformation?.heading}
                leftAlignedLink
                buttonClassName="text-color"
                ariaDescribedBy={`${props.questionType}-info`}
                modalAriaLabel={props.moreInformation?.modalAriaLabel || ''}
              />
            </div>
          )}
        </>
      );
    } else if (props.inputType === 'Dropdown') {
      return (
        <>
          <EnquiryOptionDropDown
            questionType={props.questionType}
            options={props.options}
            selectedValue={props.selectedValue}
            placeholderText={props.placeholderText}
            helpText={props.helpText}
            handleChange={props.handleChange}
            labelText={props.labelText}
            ariaDescribedBy={`${props.questionType}-info`}
            labelDescription={props.labelDescription}
          />
          {props.moreInformation && (
            <div className="pt-1">
              <InformationModal
                linkText={props.moreInformation?.text}
                modalContent={props.moreInformation?.description}
                leftAlignedLink
                buttonClassName="text-color"
                ariaDescribedBy={`${props.questionType}-info`}
                modalAriaLabel={props.moreInformation?.modalAriaLabel || ''}
              />
            </div>
          )}
        </>
      );
    } else if (props.inputType === 'Textbox') {
      return (
        <>
          <EnquiryOptionTextBox
            questionType={props.questionType}
            selectedValue={props.selectedValue}
            handleChange={props.handleChange}
            placeholderText={props.placeholderText}
            helpText={props.helpText}
            disabledHelpText={props.disabledHelpText}
            labelText={props.labelText}
            isValid={props.isValid}
            disabled={props.isDisabled}
            immutable={props.isImmutable}
            errorMessage={props.errorMessage}
            isNumeric={props.isNumeric}
            postfixText={props.postfixText}
            ariaDescribedBy={`${props.questionType}-info`}
          />
          {props.moreInformation && (
            <div className="pt-2">
              <InformationModal
                linkText={props.moreInformation?.text}
                modalContent={props.moreInformation?.description}
                leftAlignedLink
                buttonClassName="text-color"
                ariaDescribedBy={`${props.questionType}-info`}
                modalAriaLabel={props.moreInformation?.modalAriaLabel || ''}
              />
            </div>
          )}
        </>
      );
    } else if (props.inputType === 'ConsentCheckbox') {
      return (
        <>
          <EnquiryOptionConsentCheckBox
            inputType={props.inputType}
            questionType={props.questionType}
            selectedValue={props.selectedValue}
            handleChange={props.handleChange}
            alignCenter={props.alignCenter}
            labelText={props.labelText}
            labelDescription={props.labelDescription}
            helpText={props.helpText || ''}
            isVertical={props.isVertical}
            checkboxText={props.checkboxText}
            isChecked={props.isChecked}
            terms={props.terms}
          />
        </>
      );
    }
    return undefined;
  };

  return (
    <div className={props.isMarginTop ? 'enquiry-item' : 'pt-2 pt-md-3 pl-md-0 enquiry-item'}>
      {renderOptions()}
    </div>
  );
};
